module.exports = __webpack_public_path__ + "img/error.7c05ba1a.png";